import "es6-promise/auto";
import "@babel/polyfill";

//global scripts
import Vue from 'vue'
import VueRouter from 'vue-router'
import DashboardPlugin from './dashboard-plugin'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store  from '@/store/index'
import VueSlimScroll from 'vue-slimscroll'
import './common/resources/filters.js'
import crypto from '@/common/resources/crypto.js'
import ociUtils from '@/common/resources/ociUtils.js'
import OciSockets from '@/common/resources/OciSockets.js'
// Plugins
import App from './App.vue'

// router setup
//import routes from './routes/routes'
import routes from './routes/auth-routes'
import VeeValidate from 'vee-validate';



import VueKindergarten from 'vue-kindergarten';
import child from './child'
import { createSandbox } from 'vue-kindergarten';
import RouteGoverness from './routeGoverness';
import * as perimeters from './perimeters';
// import basePerimeter from './perimeters/base';
// import developerPerimeter from './perimeters/developerPerimeters'

// plugin setup
Vue.use(VueRouter)
// ACL controls
// reference: https://github.com/JiriChara/vue-kindergarten
Vue.use(VueKindergarten, {
  // Get current user.
  child,
});

Vue.use(DashboardPlugin)
// rest http plugin setup
Vue.use(VueAxios, axios)
Vue.use(VueSlimScroll)
Vue.use(OciSockets)
//Custom V-Validate rule
Vue.use(VeeValidate);
VeeValidate.Validator.extend('verify_password', {
  getMessage: field => `Password must contain at least: 8 characters, 1 uppercase letter, 1 lowercase letter, 1 number, , 1 special character (E.g. , . _ & ? ! etc)`,
  validate: value => {
    var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    return strongRegex.test(value);
  }
});


//Vue.axios.defaults.baseURL = 'https://auth.dev.oneclose.ca'

// auth engine plugin setup
// Vue.use(require('@websanova/vue-auth'), {
//   auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
//   http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
//   router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
//   rolesVar: 'role',
//   ociOauth2Data: {
//     clientId: '@!DCFC.9449.4E81.E6B4!0001!0F0A.472D!0008!7DCF.EB3D.9C45.FAEF'
//   }
// })

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  /**
   * Function that is called on route change to determine how to scroll on the page
   * Currently resets to top of page
   * @param to
   * @param from
   * @param savedPosition
   * @returns {{x: number, y: number}}
   */
  scrollBehavior (to, from, savedPosition){
    return{ x: 0, y: 0}
  },
  linkActiveClass: 'active',
  mode: 'history'
});
//middleware to check for user being logged in before each route
router.beforeEach((to, from, next) => {
/*
  // injecting second level of requiresAuth.  page/component level access control managed by vue-kindergarten rules
  // doing it before the userRoles until refactor..  easiest to dump it in here.
  // @TODO: refactor for closer tie-in of vue-kindergarten and requiresAuth routing
  if (to.matched.some(record => {
    if (record.meta.perimeter) {
      const perimeter = record.meta.perimeter;
      const Governess = record.meta.governess || RouteGoverness;
      const action = record.meta.perimeterAction || 'route';

      const sandbox = createSandbox(child(store), {
        governess: new RouteGoverness({ from, to, next }),
        perimeters: [
          perimeter
        ],
      });
      return sandbox.guard(action, {to, from, next});
    }
  }));
  */

  // clear id Token , needed to avoid storage of cognito token across users
  if(to.path!=="/auth/login"){
    sessionStorage.removeItem("oca")
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
     if(sessionStorage.getItem('ocu')  && sessionStorage.getItem('ocu') !== 'null' ) {
       // TODO - add further check apart from it's present. validate token
      //First make sure appUser data is loaded into state
      let userToken = sessionStorage.getItem('ocu');
      if (store.getters.appUser!==null){
          if(store.getters.appUser.userId<1) {
          let currentUser = jwt_decode(userToken)
            store.commit('LOAD_APP_USER',currentUser);
            store.commit('SET_USER_ROLES');

         }
        //Then check if user role matches permission on route
        to.matched.some(record=>{
          var authorized = false;
          var userRoles = store.getters.appUser.roles;
          if (record.meta.requiresAuth === true && record.meta.permissions) {
              for (let j = 0; userRoles && j < userRoles.length;j++) {
              for (let i = 0; i < record.meta.permissions.length; i++) {
                if(authorized===true){
                  break;
                }
                if ( record.meta.permissions[i] === userRoles[j].role || record.meta.permissions[i] === userRoles[j].group) { // match on either role or group
                  authorized = true;
                  next();
                  break;
                }
                else {
                  authorized = false
                }
              }
            }
            if (authorized === false) {
              next({path: '/unauthorized'})
            }
          } else if (record.meta.requiresAuth === true && !record.meta.permissions) {
            console.error('requires auth = true but no permissions/role set')
          }
        })
      }
      next()
    }
    else  {
        next({
        path: '/auth/login',
        query: { redirect: to.fullPath }
      })
    }
  } else if (sessionStorage.getItem('ocu')  && sessionStorage.getItem('ocu') !== 'null') {
    let userToken = sessionStorage.getItem('ocu');
    if (store.getters.appUser.userId < 1) {
       let currentUser = jwt_decode(userToken)
      store.commit('LOAD_APP_USER',currentUser);
      store.commit('SET_USER_ROLES');
    }
  }
  next() // make sure to always call next()!
});

Vue.config.productionTip = false;
Vue.config.performance = true;

Vue.mixin({
  // TODO: Consider adding standard sweet alert as Vue Mixin & refactoring current usages

  methods:{
    ociEncode: function (value){
      return this.$ociUtils.global.ociEncode(value);
    },
    /**
     * Returns a copy object of a JSON object.
     * Avoids issue of '=' only returning a reference.
     * I.e.
     * let newJson = oldJson
     * newJson will be a pointer, rather than a new, separate object.
     *
     * @param jsonObject - JSON Object to be copied
     * @return {any} - Copy of input JSON Object
     */
    ociCopyJson: function(jsonObject){
      return JSON.parse(JSON.stringify(jsonObject));
    },
    /**
     * Attempts to register a single Vuex Store Module.
     * Will first attempt to unregister all known modules first (avoids double registration and module overlap).
     * @param moduleName - String - Name of the module to register
     * @param module - Object - The module to register
     */
    ociRegisterModule: function(moduleName, module){
      try{
        this.$store.unregisterModule('lawyerModule');
      }catch(error){
        this.ociDebug("No lawyer module registered");
      }
      try{
        this.$store.unregisterModule('salesModule');
      }catch(error){
        this.ociDebug("No sales module registered");
      }
      try{
        this.$store.unregisterModule('brokerModule');
      }catch(error){
        this.ociDebug("No broker module registered");
      }
      try{
        this.$store.unregisterModule('developerModule');
      }catch(error){
        this.ociDebug("No developer module registered");
      }
      try{
        this.$store.unregisterModule('lenderModule');
      }catch(error){
        this.ociDebug("No lender module registered");
      }
      try{
        this.$store.unregisterModule('ociModule');
      }catch(error){
        this.ociDebug("No OCI-internal module registered");
      }
      try{
        this.$store.unregisterModule('partnerModule');
      }catch(error){
        this.ociDebug("no partner module registered");
      }
      try{
        this.$store.unregisterModule('purchaserModule');
      }catch(error){
        this.ociDebug("No purchaser module loaded");
      }
      try{
        this.$store.unregisterModule('superUserModule');
      }catch(error){
        this.ociDebug("No super user module registered");
      }
      try{
        this.$store.registerModule(moduleName, module);
        this.ociInfo(moduleName + " registered");
      }catch{
        this.ociError("Failed to register module: " + "'" + moduleName + "'");
      }
    },
    /*The following methods are globally-available wrappers for functions found in ociUtils.js*/
    ociLog: function(...args){
      this.$ociUtils.global.ociEnvLog(...args);
    },
    ociAssert: function(...args){
      this.$ociUtils.global.ociEnvAssert(...args);
    },
    ociDebug: function(...args){
      this.$ociUtils.global.ociEnvDebug(...args);
    },
    ociError: function(...args){
      this.$ociUtils.global.ociEnvError(...args);
    },
    ociGroup: function(...args){
      this.$ociUtils.global.ociEnvGroup(...args);
    },
    ociGroupEnd: function(){
      this.$ociUtils.global.ociEnvGroupEnd();
    },
    ociInfo: function(...args){
      this.$ociUtils.global.ociEnvInfo(...args);
    },
    ociTable: function(tabularData){
      this.$ociUtils.global.ociEnvTable(tabularData);
    },
    ociTrace: function(...args){
      this.$ociUtils.global.ociEnvTrace(...args);
    },
    ociWarn: function(...args){
      this.$ociUtils.global.ociEnvWarn(...args);
    }
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  OciSockets,
  VeeValidate,
 render: h => h(App),
  router,

});

/* We import element-ui variables at the end so they can override the default element-ui colors */
import './assets/sass/element_variables.scss'
import jwt_decode from "jwt-decode";
